const CAPTCHA_PUBLIC_KEY = '6LfHbIUtAAAAAGSMGOREinErDgw2cwUewxZPZlL6'

const handleCaptcha = (form: HTMLFormElement, onSuccess?: () => void) => {
  let isValidate = true

  const allInputs = form.querySelectorAll('input, textarea')

  allInputs.forEach((input) => {
    if (!isInputElement(input)) return

    if (!input.checkValidity()) {
      if (isValidate) {
        input.reportValidity()
      }

      isValidate = false
    }
  })

  if (isValidate) {
    initializeRecaptcha(form, onSuccess)
  }

  // Add listeners to validate form when user stop changing
  // Validate form with default and custom validation
  // const allInputs = form.querySelectorAll('input, textarea')

  allInputs.forEach((input) => {
    // Remove info that validation has already been reported when user focus
    input.addEventListener('change', () => {
      input.setAttribute('data-focused', 'true')
    })

    input.addEventListener('focusout', () => {
      // Check if user focused and if true, on focus out check validity
      // Its like this to prevent infinite reportValidity when user just wants to click outside
      if (input.getAttribute('data-focused') !== 'false') {
        input.setAttribute('data-focused', 'false')

        if (isInputElement(input) && !input.checkValidity()) {
          input.reportValidity()
        }
      }
    })
  })
}

const submitAjax = async (form: HTMLFormElement) => {
  if (!form.hasAttribute('data-sending')) {
    form.setAttribute('data-sending', 'true')

    // Show loader on mouse
    document.body.style.cursor = 'progress'

    // Get url from action attr
    const url = form.getAttribute('action')

    // Get all data from form
    const data = new FormData(form)

    let isValidate = true
    // Validate form with default and custom validation
    const allInputs = form.querySelectorAll('input, textarea')

    allInputs.forEach((input) => {
      let isInputValidate = false

      if (!isInputElement(input)) return

      isInputValidate = input.checkValidity()

      // If is not validate set attr that not every element is valid
      if (!isInputValidate) {
        isValidate = false
      }
    })

    if (isValidate && typeof url === 'string') {
      const result = await fetch(url, {
        method: 'post',
        body: data,
      })

      if (result.ok) {
        form.removeAttribute('data-sending')
      }
    }
  }
}

const initializeRecaptcha = (
  form: HTMLFormElement,
  onSuccess?: () => void,
) => {
  grecaptcha.ready(() => {
    grecaptcha
      .execute(CAPTCHA_PUBLIC_KEY, {
        action: 'submit',
      })
      .then((token) => {
        // Add your logic to submit to your backend server here.
        // After token has been generated create/update hidden input with captcha
        let tokenCaptcha = form.querySelector(`[name='recaptcha_response']`)

        if (tokenCaptcha && isFormElement(tokenCaptcha)) {
          // If token exists, update token value
          tokenCaptcha.value = token
        } else {
          // If token does not exist create it
          tokenCaptcha = document.createElement('input')
          tokenCaptcha.setAttribute('name', 'recaptcha_response')
          tokenCaptcha.setAttribute('id', 'recaptchaResponse')
          tokenCaptcha.setAttribute('type', 'hidden')
          tokenCaptcha.setAttribute('value', token)

          // Add token to form
          form.appendChild(tokenCaptcha)

          // Send form to server
          // submitAjax(form)
        }
        onSuccess?.()
        return form.submit()
      })
  })
}

const isFormElement = (form: Element): form is HTMLFormElement => {
  if (form instanceof HTMLFormElement) {
    return true
  }

  return false
}

const isInputElement = (input: Element): input is HTMLInputElement => {
  if (input instanceof HTMLInputElement) {
    return true
  }

  return false
}

export default handleCaptcha
